import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/layout/Sidebar';
import Navbar from './components/layout/Navbar';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/auth/Login';
import Signup from './pages/auth/Signup';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from './contexts/ThemeContext';
import SipAccountManagement from './pages/sip-account/SipAccountManagement';
import LockManagement from './pages/Lock/LockManagement';
import CommunityManagement from './pages/community/CommunityManagement';
import RoomSipAccount from './pages/setting/RoomSipAccount';
import DoorLockConfig from './pages/setting/DoorLockConfig';
import StaffSipAccount from './pages/setting/StaffSipAccount';
import VisitorPage from './pages/visitor/VisitorPage';
import CallCenter from './pages/callcenter/CallCenter';
import { CallAgentVisitPage } from './pages/callagent';
import { ECardVisitPage } from './pages/ecard';
import EcardSetting from './pages/ecard-setting/ECardSetting';

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const { isAuthenticated } = useSelector(state => state.auth);

  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/visitor" element={<VisitorPage />} />
            <Route path="/callcenter" element={<CallAgentVisitPage />} />
            <Route path="/ecard" element={<ECardVisitPage />} />
            <Route
              path="/login"
              element={isAuthenticated ? <Navigate to="/sip-account-management" /> : <Login />}
            />
            <Route
              path="/signup"
              element={isAuthenticated ? <Navigate to="/sip-account-management" /> : <Signup />}
            />
            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <div className="flex flex-col h-screen bg-skin-main">
                    <Navbar />
                    <div className="flex flex-1 overflow-hidden">
                      <Sidebar
                        isOpen={isSidebarOpen}
                        onToggle={() => setIsSidebarOpen(!isSidebarOpen)}
                      />
                      <main className="flex-1 bg-skin-primary rounded-lg overflow-hidden">
                        <Routes>
                          <Route
                            path="/"
                            element={<Navigate to="/community-management" replace />}
                          />
                          <Route
                            path="/sip-account-management"
                            element={<SipAccountManagement />}
                          />
                          <Route path="/lock-management" element={<LockManagement />} />
                          <Route path="/community-management" element={<CommunityManagement />} />
                          <Route path="/room-sip-account" element={<RoomSipAccount />} />
                          <Route path="/door-lock-config" element={<DoorLockConfig />} />
                          <Route path="/staff-sip-account" element={<StaffSipAccount />} />
                          <Route path="/call-center-management" element={<CallCenter />} />
                          <Route path="/ecard-setting" element={<EcardSetting />} />
                        </Routes>
                      </main>
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
          </Routes>
          <ToastContainer />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
